import React from 'react'
import { Typography, Link as MUILink } from '@material-ui/core'

import Link from 'ui/Link'
import theme from '../theme'

const TextLink = ({ external, to, children, onClick, ...props }) => {
  const LinkComponent = external ? MUILink : Link
  const linkProps = {
    ...props,
    onClick,
    css: { textDecoration: 'none' },
    ...(external ? { href: to } : { to }),
  }

  return to ? (
    <LinkComponent {...linkProps}>
      <Content {...props}>{children}</Content>
    </LinkComponent>
  ) : (
    <Content css={{ cursor: 'pointer' }} onClick={onClick || goBack} {...props}>
      {children}
    </Content>
  )
}

const Content = ({ children, ...props }) => (
  <Typography
    variant="body2"
    color="primary"
    css={{
      textDecoration: 'none',
      marginTop: theme.spacing(2),
    }}
    {...props}
  >
    {children}
  </Typography>
)

export const goBack = () => window.history.back()

export default TextLink
